import type { ComboboxItemProps } from '@base-ui/react';

import { Combobox as BaseCombobox } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Icon } from '../../Icon/Icon';
import { itemIndicatorStyle, itemStyle } from '../form.css';

type Props = ComboboxItemProps;

export const ComboboxItem = ({ children, ...delegated }: Props) => {
  return (
    <BaseCombobox.Item {...delegated} className={clsxs(itemStyle, delegated.className)}>
      <span>{children}</span>

      <BaseCombobox.ItemIndicator className={itemIndicatorStyle}>
        <Icon name="Check" />
      </BaseCombobox.ItemIndicator>
    </BaseCombobox.Item>
  );
};
